var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 46,
    viewBox: "0 0 175 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#F5FFF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.5299C6 24.5562 6.73118 26.5185 8.05375 28.0649C9.37632 29.6113 11.215 30.6351 13.2365 30.955C15.258 31.275 17.3225 30.8697 19.0644 29.8139C20.8064 28.7581 22.1182 27.1158 22.7526 25.1961C23.387 23.2658 23.3117 21.1755 22.5375 19.2986C21.7633 17.4216 20.344 15.8752 18.5268 14.9474C16.7096 14.0195 14.6236 13.7636 12.6344 14.2222C10.6451 14.6807 8.89245 15.8325 7.67741 17.4642L14.5913 22.5193H6V22.5299Z",
    fill: "#01C37D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 22.5299C41 24.5562 40.2689 26.5185 38.9463 28.0649C37.6237 29.6113 35.785 30.6351 33.7635 30.955C31.742 31.275 29.6775 30.8697 27.9356 29.8139C26.1937 28.7581 24.8819 27.1158 24.2475 25.1961C23.6131 23.2658 23.6883 21.1755 24.4625 19.2986C25.2367 17.4216 26.6561 15.8752 28.4732 14.9474C30.2904 14.0195 32.3764 13.7636 34.3657 14.2222C36.3549 14.6807 38.1076 15.8325 39.3226 17.4642L32.4087 22.5193H41V22.5299Z",
    fill: "#01C37D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5054 26.6464L26.2043 29.3232L23.5054 32L20.8065 29.3232L23.5054 26.6464Z",
    fill: "#01C37D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.974 33.5H95.1354V13.0827H101.325V27.6772H108.974V33.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6771 33.5H86.4876C86.4876 33.5 83.1432 28.1873 82.4819 27.0302C82.4819 27.0302 82.4444 32.3305 82.4819 33.5H76.2924V13.0703H82.4819C82.8562 13.7297 86.3877 21.8419 86.4876 22.0285V13.0703H92.6771C92.6397 15.5462 92.6397 32.318 92.6771 33.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.834 33.5H67.7443L65.4232 19.6769L63.1022 33.5H57L60.2819 13.0329H70.5645L73.834 33.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175 33.5H166.29L160.699 27.9384V33.5H154.51V13.0952H160.699V18.6692L166.29 13.0952H174.825L164.805 23.2976L175 33.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.433 22.4515C111.433 24.8155 112.281 27.1048 113.816 28.9089C115.351 30.713 117.485 31.9074 119.831 32.2807C122.177 32.6539 124.573 32.1811 126.595 30.9494C128.616 29.7176 130.139 27.8016 130.875 25.562C131.611 23.31 131.524 20.8714 130.625 18.6816C129.727 16.4918 128.08 14.6877 125.971 13.6052C123.862 12.5228 121.441 12.2242 119.132 12.7592C116.824 13.2942 114.79 14.6379 113.379 16.5416L121.403 22.4391H111.433V22.4515Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.051 22.4515C152.051 24.8155 151.203 27.1048 149.668 28.9089C148.133 30.713 145.999 31.9074 143.653 32.2807C141.307 32.6539 138.911 32.1811 136.89 30.9494C134.868 29.7176 133.346 27.8016 132.609 25.562C131.873 23.31 131.96 20.8714 132.859 18.6816C133.757 16.4918 135.405 14.6877 137.514 13.6052C139.622 12.5228 142.043 12.2242 144.352 12.7592C146.661 13.2942 148.695 14.6379 150.105 16.5416L142.081 22.4391H152.051V22.4515Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M131.748 27.2542L134.88 30.3771L131.748 33.5L128.616 30.3771L131.748 27.2542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameLogo);
export default __webpack_public_path__ + "static/media/Frame_logo.2102173259f59ccbe2879994d1b66123.svg";
export { ForwardRef as ReactComponent };